<template>
  <div>
    <horizontal-bar-chart
      :chart-data="chartData"
      :options="chartOptions"
    />
  </div>
</template>

<script>
import { HorizontalBar } from 'vue-chartjs'
import { reactiveProp } from 'vue-chartjs/es/mixins'

export default {
  name: 'HorizontalBarChart',
  components: {
    horizontalBarChart: {
      extends: HorizontalBar,
      mixins: [reactiveProp],
      props: ['chartData', 'options'],
      mounted() {
        this.renderChart(this.chartData, this.options)
      },
      watch: {
        chartData(newData) {
          this.renderChart(newData, this.options)
        },
      },
    },
  },
  props: {
    chartData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'top',
          },
        },
        scales: {
          x: {
            beginAtZero: true,
          },
        },
      },
    }
  },
}
</script>

<style scoped>
div {
  height: 400px;
}
</style>
